<template>
  <div
    class="chat-options-menu"
    :class="showClass"
  >
    <ul class="chat-options-menu__fl">
      <li v-for="item in menu">
        <a @click="goTo(item, null)">
          <span v-html="item.label" />
          <img
            v-if="item.submenu &amp;&amp; item.submenu.length&gt;0"
            class="forward-icon"
            src="../../assets/img/chatbot/arrow-next.png"
            width="7px"
            height="14px"
          >
        </a>
      </li>
    </ul>
    <ul
      v-for="item in menu"
      v-if="item.submenu &amp;&amp; item.submenu.length&gt;0"
      :id="item.id"
      class="chat-options-menu__sl"
      :class="{'show' : item.submenuShowed}"
    >
      <li>
        <a
          class="go-back"
          @click="goBack(item)"
        >
          <img
            class="backward-icon"
            src="../../assets/img/chatbot/arrow-back.png"
            width="7px"
            height="14px"
          >
          <span v-html="item.label" />
        </a>
      </li>
      <li v-for="subitem in item.submenu">
        <a @click="goTo(item, subitem)">{{ subitem.label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>

const _NAME = "Brand Name";

export default {
    name: "MenuBot",
    props: ["show", "callback",],
    data() {
        return {
            subMenuActived: null,
            menu: [
                {
                    label: "Scopri <strong>" + _NAME + "</strong>",
                    url: "",
                    subjects: ["scopri",],
                    submenu: [],
                },
                {
                    label: "Che offerte avete?",
                    url: "",
                    subjects: ["offerte",],
                    submenu: [],
                },
                {
                    label: "Dove acquisto la SIM?",
                    url: "",
                    subjects: ["dove",],
                    submenu: [],
                },
            ],
        };
    },
    computed: {
        showClass() {
            return {
                "menu-show": this.show,
            };
        },
    },
    updated() {
        if (!this.show) {
            this.menu.forEach(function (e) {
                e.submenuShowed = false;
            });
        }
    },
    methods: {
        activeSubMenu(elem) {
            this.subMenuActived = elem;
        },
        subMenuActivated(_thisElem) {
            return {
                "test": (_thisElem == this.subMenuActived),
            };
        },
        goTo(item, subitem) {
            if (subitem) {
                item.submenuShowed = false;
                this.callback(subitem);
            } else {
                if (item.submenu && item.submenu.length > 0) {
                    item.submenuShowed = true;
                } else {
                    this.callback(item);
                }
            }
        },
        goBack(item) {
            item.submenuShowed = false;
        },
    },
};
</script>

<style lang="scss">
    @import "../../assets/styles/scss/chatbot/commons";

    $menuwidth: 420px;
    .chat-options-menu {
        z-index: 9000;
        position: fixed;
        width: $menuwidth;
        max-width: 93%;
        right: 10px;
        bottom: -120%;
        @include transition(bottom 0.3s ease-in-out);
        background-color: #fff;
        box-shadow: 0 10px 50px 0 rgba(130, 156, 222, 0.35);
        border-radius: 6px;

        &.menu-show {
            bottom: 80px;
        }

        &:after, &:before {
            top: 100%;
            right: 7px;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }

        &:after {
            border-color: rgba(255, 255, 255, 0);
            border-top-color: #ffffff;
            border-width: 10px;
            margin-left: -10px;
        }

        @include e('fl') {
            padding: 0px;
            margin: 0px;
            padding: 0 15px 10px 14px;
            position: relative;
            z-index: 9000;
            li {
                list-style: none;
                border-bottom: solid 1px #cad1dd;

                &:last-child {
                    border: none
                }

                a {
                    text-decoration: none;
                    cursor: pointer;
                    font-family: $font-book;
                    font-size: 18px;
                    line-height: 1.33;
                    text-align: left;
                    color: #37383c;
                    width: 100%;
                    display: flex;
                    display: -webkit-flex;
                    align-items: center;
                    padding: 14px 0px;

                    .forward-icon {
                        margin-left: auto;
                    }

                    .backward-icon {
                        float: left
                    }

                    strong {
                        font-family: $font-bold;
                    }

                    &:hover {
                        text-decoration: none;
                    }

                    &.go-back {
                        span {
                            text-align: center;
                            width: 100%;
                        }
                    }
                }
            }
        }

        @include e('sl') {
            @extend .chat-options-menu__fl;
            @include transition(right 0.3s ease-in-out);
            background-color: #fff;
            box-shadow: 0 1px 20px 0 rgba(130, 156, 222, 0.15);
            border-radius: 6px;
            position: fixed;
            bottom: 80px;
            right: -450px;
            width: $menuwidth - 20px;
            max-width: 88%;
            z-index: 9001;
            &.show {
                right: 10px;
            }
        }
    }
</style>
